var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleevesD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 181,
    viewBox: "0 0 213 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5866 6.20313C71.8085 5.42374 73.4213 5.42208 75.3327 5.91205C76.278 18.3251 88.0741 24.9855 106.588 24.9855C124.906 24.9855 136.747 18.4666 137.918 6.30478C139.024 5.73669 141.868 5.4181 143.251 6.47056C152.119 9.30899 161.048 12.3195 168.7 14.8992C172.112 16.0495 175.27 17.1141 178.055 18.0396C194.218 23.411 203.937 68.136 207.675 99.0207C203.119 103.513 190.351 109.06 165.839 109.06V181.001H106.5H47.3234V109.473C22.811 109.473 9.88124 103.513 5.3252 99.0207C9.06349 68.136 18.7822 23.411 34.9453 18.0396C37.7305 17.1141 40.8883 16.0495 44.3001 14.8992L44.3001 14.8992C52.1929 12.2382 61.4448 9.11907 70.5866 6.20313Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2077 20.8486C16.865 32.3761 8.68283 71.2811 5.3252 99.0208C9.59544 103.705 23.2239 110.039 47.5378 110.094C46.9359 87.9577 46.7433 54.237 48.4217 51.2714L48.4385 51.2421C47.4589 43.3839 41.0479 34.0318 35.4712 26.823C33.6355 24.45 31.7546 22.6885 30.2077 20.8486Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8548 119.723V120.263H47.8768C47.8695 120.085 47.8621 119.905 47.8548 119.723Z",
    fill: "#191919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.485 20.6211C196.113 31.3709 204.483 70.6401 207.841 98.3798C203.571 103.064 189.942 109.398 165.628 109.453C166.23 87.3167 166.423 53.5961 164.744 50.6304L164.728 50.6011C165.707 42.7429 172.118 33.3908 177.695 26.182C179.53 23.8091 180.938 22.4609 182.485 20.6211Z",
    fill: "#191919"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.311 119.082V119.622H165.289C165.297 119.444 165.304 119.264 165.311 119.082Z",
    fill: "#191919"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5664 17.4133C45.3483 14.0553 56.997 9.89498 70.3556 5.86953C71.1844 5.45729 73.7536 4.88015 75.7427 5.86952C76.157 13.2897 81.3013 18.927 87.9315 21.8126C79.3352 26.5883 59.3925 39.0725 48.3929 50.803C46.7078 43.255 36.7082 27.9233 29.917 20.9752C31.6705 19.2272 33.5908 18.0915 35.5664 17.4133Z",
    fill: "#191919"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.444 17.4133C167.662 14.0553 156.014 9.89498 142.655 5.86953C141.826 5.45729 139.257 4.88015 137.268 5.86952C136.854 13.2897 131.709 18.927 125.079 21.8126C133.676 26.5883 153.618 39.0725 164.618 50.803C166.303 43.255 176.303 27.9233 183.094 20.9752C181.34 19.2272 179.42 18.0915 177.444 17.4133Z",
    fill: "#191919"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.633 110.636C23.1616 110.636 9.6045 104.121 5.05612 99.5916C4.6419 97.5243 5.09069 93.4461 6.15472 91.2666C11.9415 96.2857 29.3959 100.636 47.633 101.155V110.636Z",
    fill: "#9A9A9A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.425 109.928C189.896 109.928 203.128 104.909 207.676 100.38C208.505 98.7231 208.09 93.3379 206.847 91.2666C201.06 96.2857 184.077 100.726 165.84 101.245L165.425 109.928Z",
    fill: "#9A9A9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_564_13054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 91,
    width: 205,
    height: 20
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.633 110.636C23.1616 110.636 9.6045 104.121 5.05612 99.5916C4.6419 97.5243 5.09069 93.4461 6.15472 91.2666C11.9415 96.2857 29.3959 100.636 47.633 101.155V110.636Z",
    fill: "#D3D3D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.425 109.928C189.896 109.928 203.128 104.909 207.676 100.38C208.505 98.7231 208.09 93.3379 206.847 91.2666C201.06 96.2857 184.077 100.726 165.84 101.245L165.425 109.928Z",
    fill: "#D3D3D3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_564_13054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1406,
    y: 68.4541,
    width: 25.9427,
    height: 46.0113,
    transform: "rotate(15 20.1406 68.4541)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.9427,
    height: 46.0113,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 193.291 68.4541)",
    fill: "#464646"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3963 5.68649C73.5524 4.9969 70.0658 5.54658 68.8711 6.29874C68.8711 21.4718 84.4579 31.6134 106.277 31.6134C128.096 31.6134 143.508 21.6395 143.508 6.46648C142.249 5.21833 138.177 5.09831 136.767 5.59943C135.834 17.8165 124.365 24.3697 106.526 24.3697C88.7294 24.3697 77.3702 17.8465 76.3963 5.68649Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleevesD);
export default __webpack_public_path__ + "static/media/Sleeves D.22367a7b3513a455bd38f3c476f2d3a1.svg";
export { ForwardRef as ReactComponent };